import { createSlice } from '@reduxjs/toolkit';

const initialSuperAdminAuthState = {
  //null = loaded but empty, undefined = not loaded yet
  authToken: undefined
};
export const SuperAdminAuthSlice = createSlice({
  name: 'superAdminAuth',
  initialState: initialSuperAdminAuthState,
  reducers: {
    setSuperAdminToken: (state, action) => {
      //token loaded but empty
      state.authToken = action.payload.authToken || null;
    },
    clearSuperAdminToken: state => {
      state.authToken = null;
    }
  }
});

export const superAdminAuthReducer = SuperAdminAuthSlice.reducer;
export const superAdminAuthActions = SuperAdminAuthSlice.actions;
